//open workable on a new tab
jQuery(document).on('click', 'li.whr-item a', function(e) {
e.preventDefault();
window.open(this.href, '_blank');
});